var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBorderRadiusRightTop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 10.0416C3.35675 10.0416 3.37508 10.0233 3.37508 9.99998C3.37508 9.97665 3.35675 9.95831 3.33341 9.95831C3.31008 9.95831 3.29175 9.97665 3.29175 9.99998C3.29175 10.0233 3.31008 10.0416 3.33341 10.0416",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 13.375C3.35675 13.375 3.37508 13.3567 3.37508 13.3334C3.37508 13.31 3.35675 13.2917 3.33341 13.2917C3.31008 13.2917 3.29175 13.31 3.29175 13.3334C3.29175 13.3567 3.31008 13.375 3.33341 13.375",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 6.70833C3.35675 6.70833 3.37508 6.69 3.37508 6.66667C3.37508 6.64333 3.35675 6.625 3.33341 6.625C3.31008 6.625 3.29175 6.64333 3.29175 6.66667C3.29175 6.69 3.31008 6.70833 3.33341 6.70833",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 16.7083C10.0233 16.7083 10.0416 16.69 10.0416 16.6667C10.0416 16.6433 10.0233 16.625 9.99992 16.625C9.97659 16.625 9.95825 16.6433 9.95825 16.6667C9.95825 16.69 9.97659 16.7083 9.99992 16.7083",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 16.6667C6.625 16.69 6.64333 16.7083 6.66667 16.7083C6.69 16.7083 6.70833 16.69 6.70833 16.6667C6.70833 16.6433 6.69 16.625 6.66667 16.625C6.64333 16.625 6.625 16.6433 6.625 16.6667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2917 16.6667C13.2917 16.69 13.3101 16.7083 13.3334 16.7083C13.3567 16.7083 13.3751 16.69 13.3751 16.6667C13.3751 16.6433 13.3567 16.625 13.3334 16.625C13.3101 16.625 13.2917 16.6433 13.2917 16.6667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 16.7083C3.35675 16.7083 3.37508 16.69 3.37508 16.6667C3.37508 16.6433 3.35675 16.625 3.33341 16.625C3.31008 16.625 3.29175 16.6433 3.29175 16.6667C3.29175 16.69 3.31008 16.7083 3.33341 16.7083",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 3.33335C6.625 3.35669 6.64333 3.37502 6.66667 3.37502C6.69 3.37502 6.70833 3.35669 6.70833 3.33335C6.70833 3.31002 6.69 3.29169 6.66667 3.29169C6.64333 3.29169 6.625 3.31002 6.625 3.33335",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 3.37502C3.35675 3.37502 3.37508 3.35669 3.37508 3.33335C3.37508 3.31002 3.35675 3.29169 3.33341 3.29169C3.31008 3.29169 3.29175 3.31002 3.29175 3.33335C3.29175 3.35669 3.31008 3.37502 3.33341 3.37502",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 13.2917C16.6433 13.2917 16.625 13.31 16.625 13.3334C16.625 13.3567 16.6433 13.375 16.6667 13.375C16.69 13.375 16.7083 13.3567 16.7083 13.3334C16.7083 13.31 16.69 13.2917 16.6667 13.2917",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 16.625C16.6433 16.625 16.625 16.6433 16.625 16.6667C16.625 16.69 16.6433 16.7083 16.6667 16.7083C16.69 16.7083 16.7083 16.69 16.7083 16.6667C16.7083 16.6433 16.69 16.625 16.6667 16.625",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3528 2.21075C17.4261 2.22572 17.4923 2.25844 17.55 2.30157C17.6998 2.38794 17.802 2.5479 17.802 2.73322V7.70099C17.8018 7.9769 17.5779 8.2009 17.302 8.20099C17.026 8.20092 16.8022 7.97691 16.802 7.70099V3.20001H12.3C12.0239 3.20001 11.8 2.97615 11.8 2.70001C11.8002 2.42404 12.024 2.20001 12.3 2.20001H17.2522L17.3528 2.21075Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBorderRadiusRightTop);
export default ForwardRef;